import {
  CustomChartType,
  IColumnChartBuilderConfig,
  ICustomReportChart,
} from '@principle-theorem/principle-core/interfaces';
import { ReportBuilderCharts } from '@principle-theorem/reporting';
import {
  IDCChartBuilder,
  ITableBuilder,
} from './dc-chart-builders/dc-chart-builder';
import { DcColumnChartBuilder } from './dc-chart-builders/dc-column-chart-builder';
import { DcLineChartBuilder } from './dc-chart-builders/dc-line-chart-builder';
import { DcPieChartBuilder } from './dc-chart-builders/dc-pie-chart-builder';
import { DcRowChartBuilder } from './dc-chart-builders/dc-row-chart-builder';
import { DcSelectMenuBuilder } from './dc-chart-builders/dc-select-menu-builder';
import { DcSingleValueChartBuilder } from './dc-chart-builders/dc-single-value-chart-builder';
import { TableChartBuilder } from './table-chart-builder';

export class ChartBuilder {
  static getForChart(
    chart: ICustomReportChart
  ): IDCChartBuilder<unknown> | ITableBuilder | undefined {
    switch (chart.type) {
      case CustomChartType.NumberSummary:
        return this.numberSummary();
      case CustomChartType.Table:
        return this.table();
      case CustomChartType.Column:
        return this.column(chart.builderConfig);
      case CustomChartType.Line:
        return this.line(chart.builderConfig);
      case CustomChartType.Pie:
        return this.pie();
      case CustomChartType.Row:
        return this.row();
      case CustomChartType.SelectMenu:
        return this.selectMenu();
      default:
        // eslint-disable-next-line no-console
        console.error(`ChartBuilder.get - unknown type "${chart.type}"`);
        return;
    }
  }

  static numberSummary(): DcSingleValueChartBuilder {
    return new DcSingleValueChartBuilder({
      height: 200,
      width: ReportBuilderCharts.gridSpan(1),
    });
  }

  static table(): TableChartBuilder {
    return new TableChartBuilder({
      height: 200,
      width: ReportBuilderCharts.gridSpan(2),
    });
  }

  static pie(): DcPieChartBuilder {
    return new DcPieChartBuilder({
      height: 200,
      width: ReportBuilderCharts.gridSpan(1),
    });
  }

  static row(): DcRowChartBuilder {
    return new DcRowChartBuilder({
      height: 250,
      width: ReportBuilderCharts.gridSpan(1),
    });
  }

  static column(
    builderConfig?: Partial<IColumnChartBuilderConfig>
  ): DcColumnChartBuilder {
    return new DcColumnChartBuilder({
      height: 200,
      width: ReportBuilderCharts.gridSpan(2),
      ...builderConfig,
    });
  }

  static line(
    builderConfig?: Partial<IColumnChartBuilderConfig>
  ): DcLineChartBuilder {
    return new DcLineChartBuilder({
      height: 200,
      width: ReportBuilderCharts.gridSpan(2),
      ...builderConfig,
    });
  }

  static selectMenu(): DcSelectMenuBuilder {
    return new DcSelectMenuBuilder({
      height: 200,
      width: ReportBuilderCharts.gridSpan(1),
    });
  }
}
